import React from 'react';
import { toArray } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { required } from 'redux-form-validators';

import { ENTERPRISE_CARD_PARTNER_EBC_ID } from '../../../../../../constants/ebon';

import {
    fetcheBonsByPartnerId,
    resetLock,
    resetCart
} from '../../../../../../services/ebon/actions';

import { FormComponent, SelectFieldComponent } from '../../../../../form';
import { LoadingComponent } from '../../../../../loading/LoadingComponent';

import './PaymentRequestEbonPartnerForm.scss';

const DUMMY_FORM = 'dummy-form';

const getPartnersOptions = (data = []) =>
    data
        .filter(p => p.ebcId !== ENTERPRISE_CARD_PARTNER_EBC_ID)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(item => ({ label: item.name, value: item.id }));

const PaymentRequestEbonPartnerForm = ({
    setSelectedPartnerId,
    setCappingError,
    i18n,
    i18nCommon,
    partnersOption,
    ebonPartnersFetching,
    fetcheBonsByPartnerId,
    resetLock,
    resetCart
}) => {
    const handleOnChangePartner = e => {
        resetLock();
        resetCart();
        setCappingError(false);

        const value = Number(e.target.value);
        if (value > 0) {
            setSelectedPartnerId(value);
            fetcheBonsByPartnerId(value);
        } else {
            setSelectedPartnerId(-1);
        }
    };

    return (
        <div id="payment-request-ebon-partner-selector-container" className="container">
            {ebonPartnersFetching ? (
                <p className="partnerLoading">
                    <LoadingComponent />
                </p>
            ) : (
                <FormComponent
                    form={DUMMY_FORM}
                    classNameInputContainer="payment-request-dummy-form"
                    onSubmit={null}
                    hideButton>
                    <SelectFieldComponent
                        name="partnerId"
                        label={i18n.PAYMENT_REQUEST_FORM.EBON.LABEL_PARTNER}
                        defaultOptionLabel={
                            i18n.PAYMENT_REQUEST_FORM.EBON.DEFAULT_OPTION_LABEL_PARTNER
                        }
                        classNameInputContainer="one-half mr50"
                        options={partnersOption}
                        validate={[required({ msg: i18nCommon.REQUIRED })]}
                        onChange={handleOnChangePartner}
                        isRequired
                    />
                </FormComponent>
            )}
        </div>
    );
};

PaymentRequestEbonPartnerForm.propTypes = {
    setSelectedPartnerId: PropTypes.func.isRequired,
    setCappingError: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        i18nCommon: state.i18n.feature.form,
        partnersOption: getPartnersOptions(toArray(state.ebon.ebonPartners)),
        ebonPartnersFetching: state.ebon.ebonPartnersFetching
    };
};

const mapDispatchToProps = {
    fetcheBonsByPartnerId,
    resetLock,
    resetCart
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(PaymentRequestEbonPartnerForm)
);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/payment-requests/ebon/PaymentRequestEbonPartnerForm.js